import React, { useState } from "react";
import { ModalCompAdvance } from "../../../components";
import { convertToTitleCase } from "../../../utils/helpers";
import FallbackImage from "../../../components/Common/ImageWrapper";

const DEFAULT_AVATAR =
  "https://res.cloudinary.com/dammymoses/image/upload/v1654672815/avatars/avatar_wv2acz.svg";

function statusColor(status) {
  if (status === "CONFIRMED") return "#19BC31";
  if (status === "DECLINED") return "#FF4343";
  return "#FFA500";
}

export default function MemberLoanRepaymentGuarantorsCell({ guarantors = [] }) {
  const [open, setOpen] = useState(false);

  const list = Array.isArray(guarantors) ? guarantors.filter(Boolean) : [];

  const modalArrayComp = [
    {
      component: (
        <div className="py-2">
          <p className="text-muted small mb-3 mb-md-4">
            Basic information for guarantor(s) on this loan repayment.
          </p>
          <div className="d-flex flex-column gap-3" style={{ maxHeight: "60vh", overflowY: "auto" }}>
            {list.map((g, index) => {
              const photo = g?.photo || g?.member?.photo || DEFAULT_AVATAR;
              const name = g?.name || "—";
              const status = (g?.status || "PENDING").toUpperCase();

              return (
                <div
                  key={g?.id ?? index}
                  className="border rounded p-3"
                  style={{ borderColor: "#e0e0e0", background: "#fafafa" }}
                >
                  <div className="d-flex align-items-start gap-3">
                    <div
                      className="flex-shrink-0 rounded-circle overflow-hidden border"
                      style={{
                        width: 40,
                        height: 40,
                        borderColor: "#e0e0e0",
                      }}
                    >
                      <FallbackImage
                        src={photo}
                        alt=""
                        style={{
                          width: "40px",
                          height: "40px",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                    <div className="flex-grow-1 min-w-0">
                      <div className="fw-bold text-black1" style={{ fontSize: "14px" }}>
                        {name}
                      </div>
                      <span
                        className="d-inline-block mt-1 px-2 py-1 rounded-pill text-white"
                        style={{
                          fontSize: "11px",
                          backgroundColor: statusColor(status),
                        }}
                      >
                        {convertToTitleCase(status)}
                      </span>
                      <div className="mt-2 small text-black1">
                        {g?.email && (
                          <div className="mb-1">
                            <span className="text-muted">Email: </span>
                            {g.email}
                          </div>
                        )}
                        {g?.phone && (
                          <div className="mb-1">
                            <span className="text-muted">Phone: </span>
                            {g.phone}
                          </div>
                        )}
                        {g?.occupation && (
                          <div className="mb-1">
                            <span className="text-muted">Occupation: </span>
                            {g.occupation}
                          </div>
                        )}
                        {g?.home_address && (
                          <div className="mb-1">
                            <span className="text-muted">Address: </span>
                            {g.home_address}
                          </div>
                        )}
                        {g?.member?.member_no && (
                          <div className="mb-0">
                            <span className="text-muted">Membership Number: </span>
                            {g.member.member_no}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ),
    },
  ];

  if (list.length === 0) {
    return <span className="text-muted">N/A</span>;
  }

  const count = list.length;
  const label =
    count === 1 ? "View guarantor details" : `View guarantor details (${count})`;

  return (
    <>
      <button
        type="button"
        className="btn btn-sm border-0 text-white"
        style={{
          backgroundColor: "var(--color-secondary)",
          fontSize: "12px",
          whiteSpace: "nowrap",
          padding: "4px 10px",
          borderRadius: "8px",
        }}
        onClick={() => setOpen(true)}
        aria-label={label}
      >
        {count === 1 ? "View guarantor" : `Guarantors (${count})`}
      </button>

      <ModalCompAdvance
        show={open}
        handleClose={() => setOpen(false)}
        modalTitle={
          <span id="loan-repayment-guarantors-title" className="h5 mb-0 fw-bold px-1">
            Guarantor details
          </span>
        }
        modalBody={0}
        arrayComp={modalArrayComp}
        close
        centered
        size="lg"
        designClass="modal-body-scrollable"
      />
    </>
  );
}
